module.exports = __webpack_public_path__ + "img/headerimg.14bc5ee7.png";